import { Button } from "@alch/ui";
import { zodResolver } from "@hookform/resolvers/zod";
import { useFlags } from "@hooks/useFlag";
import { FLAG_DEFAULTS, flagSchemaMap } from "@webapp/shared";
import { Control, useForm } from "react-hook-form";
import z from "zod";
import FlagInput from "./FlagInput";
import useFlagOverrides from "./useFlagOverrides";

const schema = flagSchemaMap as unknown as z.ZodFirstPartySchemaTypes;
const resolver = zodResolver(schema);

interface FlagsFormProps {
  onSuccess?: () => void;
}

const FlagsForm = ({ onSuccess }: FlagsFormProps) => {
  const flags = useFlags();
  const { overrides, setOverrides } = useFlagOverrides();

  const form = useForm({
    defaultValues: FLAG_DEFAULTS,
    values: overrides ?? flags.data,
    resolver,
  });

  return (
    <form
      onSubmit={form.handleSubmit((values) =>
        setOverrides(values, { onSuccess }),
      )}
    >
      <div className="border-t border-grayscale-200 bg-grayscale-50 p-4">
        <FlagInput
          control={form.control as unknown as Control}
          schema={schema}
        />
      </div>

      <div className="flex gap-3 border-t border-grayscale-200 p-4">
        <Button
          type="reset"
          intent="tertiary"
          onClick={() => setOverrides(undefined, { onSuccess })}
          disabled={!overrides}
        >
          Revert
        </Button>

        <Button
          type="submit"
          className="ml-auto"
          disabled={!form.formState.isValid || !form.formState.isDirty}
        >
          Apply
        </Button>
      </div>
    </form>
  );
};

export default FlagsForm;
